<div role="dialog" aria-labelledby="dialogTitle">
    <div class="modal-content">
        <div class="modal-header {{_msgType}}">
            <i class="search-icon " [iconName]="_msgType" *ngIf="!_isLoading"></i>
            <h4 id="dialogTitle" role="header" class="modal-title module-title" *ngIf="!_isLoading">
                {{_modalTitle}}
            </h4>
            <button type="button" value="Close" class="close" aria-label="Close"
                (click)="dismiss()" tabindex="-1" [disabled]="_isLoading" title="{{'dialog.box.close.tooltip'|translate}}">
                <span class="icon-Close" aria-hidden="true"></span>
            </button>
        </div>
        <div class="modal-body">
            <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
            <div *ngIf="_showErrorMessage">
                {{_errorMessage}}
            </div>
            <div class="col-12 mb-4"  *ngIf="_showLog">
                <div class="row mt-3">
                    <div class='col-12'>
                        {{_timestamp}}
                    </div>
                </div>
                <div class="row mt-3">
                    <div class='col-12'>
                        <b id="ctPermissionsValidations">{{'import.forecast.view.log.ct.permissions.date.validations' | translate}}</b>
                        <textarea class="form-control" rows="5" cols="60" id="ctErrors" readonly>{{_ctErrors}}</textarea>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class='col-12 mt-1'>
                        <b id="validationErrors">{{'import.forecast.view.log.validation.errors' | translate}}</b>
                        <textarea class="form-control" rows="10" cols="60" id="validations" readonly>{{_validations}}</textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <breeze-button buttonText="{{'import.forecast.view.log.btn.ok' | translate}}" id="accept-btn" [isPrimary]="true" (clicked)="dismiss()" placement="top" *ngIf="!_isLoading">
            </breeze-button>
        </div>
    </div>
</div>
